import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyA8PV3CegjbiEXHRuY0EKjG4okwdj3h2j0",
  authDomain: "rednation-e1f1e.firebaseapp.com",
  projectId: "rednation-e1f1e",
  storageBucket: "rednation-e1f1e.firebasestorage.app",
  messagingSenderId: "134344292185",
  appId: "1:134344292185:web:93c0448caeb69885e93e48",
};
const app = initializeApp(firebaseConfig);
export default app;
